import { Backdrop, Box, LinearProgress } from "@mui/material"

interface Props {
    isLoading: boolean
}

export const Loading = ({ isLoading }: Props) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
        >
            <Box sx={{ width: '40%' }}>
                <LinearProgress />
            </Box>
        </Backdrop>
    )
}


